import orderTranslationsHelper from "../../../../../languages/order-translations.helper";
import {
  OrderCancelRequestErrorType,
  OrderCancelRequestOrderCancelRequestedError,
  OrderCancelRequestOrderCancelledError,
  OrderCancelRequestOrderFinishedError,
} from "./order-cancel-request-error";

const createOrderCancelError = (): OrderCancelRequestOrderCancelledError => {
  const translations =
    orderTranslationsHelper.getDetailsTranslations().cancelOrderRequest.errors;

  return {
    message: translations.orderCancelledError,
    params: {},
    type: OrderCancelRequestErrorType.ORDER_CANCELLED,
  };
};

const createOrderCancelRequestError =
  (): OrderCancelRequestOrderCancelRequestedError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().cancelOrderRequest
        .errors;

    return {
      message: translations.orderCancelRequestedError,
      params: {},
      type: OrderCancelRequestErrorType.ORDER_CANCEL_REQUESTED,
    };
  };

const createOrderFinishedError = (): OrderCancelRequestOrderFinishedError => {
  const translations =
    orderTranslationsHelper.getDetailsTranslations().cancelOrderRequest.errors;

  return {
    message: translations.orderFinishedError,
    params: {},
    type: OrderCancelRequestErrorType.ORDER_FINISHED,
  };
};

const OrderCancelRequestErrorFactory = {
  createOrderCancelError,
  createOrderCancelRequestError,
  createOrderFinishedError,
};

export default OrderCancelRequestErrorFactory;
